import { User } from '@prisma/client'
import React from 'react'
import { CommonClient } from '~/agents/common/client'
import { OnboardingValues } from '~/agents/socialMediaManager/common'
import { AppSessionType } from '~/features/appSession/common'
import { StepDaily } from './components/StepDaily'

type Props = {
  user: User
  appSession: AppSessionType
  onSubmit: () => void
}

export const Onboarding: React.FC<Props> = ({ user, appSession, onSubmit }) => {
  const hasPlatforms = (values: OnboardingValues) => {
    return (
      Object.values(values.platform ?? {}).filter(value => value === true)
        .length > 0
    )
  }

  const valuesDefault: Partial<OnboardingValues> = {
    platform: {
      linkedin: true,
      twitter: true,
      instagram: true,
      facebook: true,
      gmb: true,
    },
  }

  const logic = CommonClient.Onboarding.useLogic({
    appSession,
    valuesDefault,
    onSubmit,
  })

  return (
    <>
      <CommonClient.Onboarding.Wrapper<OnboardingValues>
        appSession={appSession}
        valuesDefault={valuesDefault}
        onSubmitted={onSubmit}
        steps={[
          {
            key: 'article',
            content: props => <StepDaily user={user} {...props} />,
          },
        ]}
      />
    </>
  )
}
